module.exports = __webpack_public_path__ + "media/bootstrap-icons/tree-fbdc5ea3.svg";